import { render, staticRenderFns } from "./addfamily.vue?vue&type=template&id=7f7c4cf9&"
import script from "./addfamily.vue?vue&type=script&lang=js&"
export * from "./addfamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports